import { Props } from './types';
import { Error } from './styled';

function ErrorMessage({ children }: Props) {
  return <Error>{children}</Error>;
}

export default ErrorMessage;
